// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jLE365N1Zr169x {
  display: block;
  position: relative;
  width: 400px;
  overflow: hidden;
  transition: padding 0.2s ease-in-out;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-400, 16px);
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
}
.jLE365N1Zr169x.yAVCmygouInImu {
  border: none;
}
.jLE365N1Zr169x.OxhqDgv8aL2OVf {
  transition: flex 0.2s ease-in-out, opacity 0.2s ease-in, border-radius 0.2s ease-in-out, margin 0.2s ease-in-out, padding 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .jLE365N1Zr169x.OxhqDgv8aL2OVf {
    transition: unset;
  }
}
.jLE365N1Zr169x.FZ2wgucq7qAMTz {
  flex-grow: 1;
  margin: var(--ds-space-0, 0);
  border: unset;
  border-radius: 0;
}
.jLE365N1Zr169x.vjD4xkEjDKR5Xd {
  width: 0px;
  margin: var(--ds-space-0, 0);
  border-width: 0;
  opacity: 0;
}
@media print {
  .jLE365N1Zr169x {
    width: 100%;
    overflow: visible;
  }
}
`, ""]);
// Exports
export var panel = `jLE365N1Zr169x`;
export var collapsed = `yAVCmygouInImu`;
export var panelTransitions = `OxhqDgv8aL2OVf`;
export var singlePanel = `FZ2wgucq7qAMTz`;
export var hidden = `vjD4xkEjDKR5Xd`;
export default ___CSS_LOADER_EXPORT___;
